/**
 * Created by Kristy Kavvada on 07/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerMedReportsWithLines', {
                parent: 'customerMedReports',
                url: '/with-lines',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportWithLines/medReportWithLines.html',
                controller: 'AdminCustomerViewMedReportsWithLinesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    medReportMedicine: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.getParameter('Med_Report_Medicine');
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
